export default "__VITE_ASSET__F78H9rba__"